const invalidNumericCharRegex = /[^0-9]/g // anything other than 0-9

export const formatNumericInput = (target, transform) => {
  let cursorPosition = target.selectionStart
  let originalSpacesCountBeforeCursor = (target.value.slice(0, cursorPosition).match(invalidNumericCharRegex) || []).length
  let number = target.value.replaceAll(invalidNumericCharRegex, "")

  if (transform) {
    target.value = transform(number) || number
  } else {
    target.value = number
  }
  let changedSpacesCountBeforeCursor = (target.value.slice(0, cursorPosition).match(invalidNumericCharRegex) || []).length
  let spacesCountBeforeCursorDiff = changedSpacesCountBeforeCursor - originalSpacesCountBeforeCursor
  cursorPosition += spacesCountBeforeCursorDiff
  target.setSelectionRange(cursorPosition, cursorPosition)

  if (!target.checkValidity()) {
    target.setCustomValidity('')
  }
}
